import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHub24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconHub24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.75 5.154a1.666 1.666 0 1 0-1.5 0v2.748a4.16 4.16 0 0 0-2.422 1.399L6.446 7.926a1.666 1.666 0 1 0-.748 1.3l2.378 1.373a4.18 4.18 0 0 0-.001 2.799l-2.38 1.375a1.666 1.666 0 1 0 .751 1.298l2.38-1.374a4.16 4.16 0 0 0 2.422 1.4v2.75a1.666 1.666 0 1 0 1.5-.002v-2.747a4.16 4.16 0 0 0 2.42-1.394l2.385 1.377a1.666 1.666 0 1 0 .744-1.303l-2.376-1.371A4.2 4.2 0 0 0 16.166 12a4.2 4.2 0 0 0-.238-1.392L18.31 9.23a1.666 1.666 0 1 0-.757-1.295l-2.376 1.372a4.16 4.16 0 0 0-2.428-1.406zM12 14.665a2.665 2.665 0 1 0 0-5.33 2.665 2.665 0 0 0 0 5.33"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHub24);
